import { render, staticRenderFns } from "./UpdateRmOrderPopUp.vue?vue&type=template&id=ffa10576&scoped=true&"
import script from "./UpdateRmOrderPopUp.vue?vue&type=script&lang=js&"
export * from "./UpdateRmOrderPopUp.vue?vue&type=script&lang=js&"
import style0 from "./UpdateRmOrderPopUp.vue?vue&type=style&index=0&id=ffa10576&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffa10576",
  null
  
)

export default component.exports